import { useTranslation } from "react-i18next";
import { SUPPORTED_LANGUAGES } from "../i18n";

/**
 * Segmented language toggle (e.g. FI | EN). Changing the language only
 * re-renders text; form state is kept. Hidden while only one language
 * is available.
 */
export function LanguageSwitcher() {
  const { t, i18n } = useTranslation();
  if (SUPPORTED_LANGUAGES.length < 2) return null;
  return (
    <div className="flex justify-end mb-2">
      <div
        role="group"
        aria-label={t("language.label")}
        className="inline-flex rounded-lg border border-gray-200 bg-white p-0.5 shadow-sm"
      >
        {SUPPORTED_LANGUAGES.map(({ code, label }) => {
          const active = i18n.resolvedLanguage === code;
          return (
            <button
              key={code}
              type="button"
              lang={code}
              title={label}
              aria-pressed={active}
              onClick={() => i18n.changeLanguage(code)}
              className={`px-2.5 py-1 text-xs font-semibold uppercase rounded-md transition-colors focus:outline-none focus:ring-2 focus:ring-blue-500 ${
                active ? "bg-blue-600 text-white" : "text-gray-600 hover:bg-blue-50 hover:text-blue-700"
              }`}
            >
              {code}
            </button>
          );
        })}
      </div>
    </div>
  );
}
